// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhzBALMp63PY_y {
  background-color: var(--dynamic-button);
  color: var(--dynamic-text);
}
.PhzBALMp63PY_y .CG6b8v8dKZpoM9 [role='img'] > svg,
.PhzBALMp63PY_y .le2qOxiQwhPwdz [role='img'] > svg,
.PhzBALMp63PY_y .E0KjGmjfrpixXU [role='img'] > svg,
.PhzBALMp63PY_y .CG6b8v8dKZpoM9 svg[role='presentation'],
.PhzBALMp63PY_y .le2qOxiQwhPwdz svg[role='presentation'],
.PhzBALMp63PY_y .E0KjGmjfrpixXU svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.PhzBALMp63PY_y svg circle {
  stroke: var(--dynamic-icon);
}
.PhzBALMp63PY_y:hover {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
}
.PhzBALMp63PY_y:hover svg circle {
  stroke: var(--dynamic-icon);
}
.PhzBALMp63PY_y:active {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-pressed);
  color: var(--dynamic-button-pressed-text);
}
.PhzBALMp63PY_y:active svg circle {
  stroke: var(--dynamic-icon);
}
.PhzBALMp63PY_y.xg_E1tMjotLhp1 {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.PhzBALMp63PY_y.xg_E1tMjotLhp1 svg circle {
  stroke: var(--dynamic-icon);
}
.PhzBALMp63PY_y.xg_E1tMjotLhp1:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.PhzBALMp63PY_y.eTemkd4Uuq3km8 {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-primary);
  color: var(--dynamic-button-primary-text);
}
.PhzBALMp63PY_y.eTemkd4Uuq3km8 svg circle {
  stroke: var(--dynamic-icon);
}
.PhzBALMp63PY_y.eTemkd4Uuq3km8:hover {
  background: var(--dynamic-button-primary-hovered);
  color: var(--dynamic-button-primary-text);
}
`, ""]);
// Exports
export var dynamicButton = `PhzBALMp63PY_y`;
export var iconBefore = `CG6b8v8dKZpoM9`;
export var iconAfter = `le2qOxiQwhPwdz`;
export var iconOnly = `E0KjGmjfrpixXU`;
export var highlighted = `xg_E1tMjotLhp1`;
export var primary = `eTemkd4Uuq3km8`;
export default ___CSS_LOADER_EXPORT___;
